'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const waitUntil=require('../../../../../dist-es6/testUtils/waitUntil');
const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const Formatters=require('../../../../../dist-es6/client/formatters');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const ErrorMessages=require('../../../../../dist-es6/client/errorMessages');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TableColumn=require('../../../../../dist-es6/client/directives/sortableTableDirective/tableColumn');

const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');

const itemsPerBatch=250;

const _RetryOptions={
retries:5,
maxTimeout:30000,
randomize:!0};


const _sortableColumnDefinitions=[{
label:'Staff ID',
defaultAscending:!0,
orderBy:['staffNumber'],
finalSort:['numAlerts','peakFatigue']},
{
label:'Peak TOD',
defaultAscending:!1,
orderBy:['peakFatigue'],
finalSort:['numAlerts','staffNumber']},

{
label:'# Alerts',
defaultAscending:!1,
isInitiallyActive:!0,
orderBy:['numAlerts','peakFatigue'],
finalSort:['staffNumber']}];let


EmiratesReportController=(_class=function(_BaseController){_inherits(EmiratesReportController,_BaseController);
function EmiratesReportController(
$scope,
$state,
$timeout,
$animate,
breadcrumbsService,
socketService,
dateService,
displaySettingsService,
timeZoneService,
paramSyncService,
notificationService,
organizationDefaultsService,
uncaughtErrorHandler){_classCallCheck(this,EmiratesReportController);var _this=_possibleConstructorReturn(this,

_BaseController.call(this,uncaughtErrorHandler,$timeout));_this.









































































































































































onSubFieldMatch=function(staffEntry,queryWords,matches){
const containsStaffNumberMatch=matches.some(function(m){return _isSameOrStartsWithString(staffEntry.staffNumber,m)});
if(containsStaffNumberMatch&&matches.length===1){
return staffEntry;
}

const numRequiredMatches=queryWords.length-(containsStaffNumberMatch?1:0);
const filteredAssignments=[];

for(let i=0;i<staffEntry.assignments.length;i++){
let numFoundMatches=0;
for(let j=0;j<matches.length;j++){
const foundMatches=staffEntry.assignments[i].searchableSubFieldData.filter(function(sfd){return _isSameOrStartsWithString(sfd,matches[j])});

numFoundMatches+=foundMatches.length;
if(numFoundMatches>=numRequiredMatches){
filteredAssignments.push(staffEntry.assignments[i]);
break;
}
}
}

if(filteredAssignments.length===0){
return;
}

const peakFatigue=_getPeakFatigueFrom(filteredAssignments);
const peakFatigueThresholdStatus=_getThresholdStatusFromFatigueAndThreshold(peakFatigue,_this.currentFatigueThreshold);

return _.defaults({
assignments:filteredAssignments,
numAlerts:filteredAssignments.reduce(_countAboveThresholdAlerts,0),
peakFatigue:peakFatigue,
peakFatigueThresholdStatus:peakFatigueThresholdStatus},
staffEntry);
};$animate.enabled(!1);_this._$scope=$scope;_this._$state=$state;_this._$timeout=$timeout;_this._breadcrumbsService=breadcrumbsService;_this._socketService=socketService;_this._dateService=dateService;_this._displaySettingsService=displaySettingsService;_this._timeZoneService=timeZoneService;_this._notificationService=notificationService;_this._organizationDefaultsService=organizationDefaultsService;_this._assignParamsToController($state.params);_this._updateUrlParamsFromController=paramSyncService.start(_this,$scope,function(newParams){return _this._updateControllerParamsFromUrl(newParams)});breadcrumbsService.dropCrumb('QA Report');_this.isUpdating=!0;_this.searchTermSeparator=/[\s,]+/gi;_this.currentNumItemsVisisble=itemsPerBatch;const searchableFields=['Staff ID','User','Fleet','Pairing','Pairing Date','Flight','Location','Rank'];_this.searchableFieldsHelpText=`Search ${searchableFields.join(', ')}`;_this._tableColumns=_sortableColumnDefinitions.map(TableColumn.fromColumnDefinition);_this._activeColumn=_.find(_this._tableColumns,{isActive:!0});_this._$scope.$watchCollection('controller.filteredEntries',_.debounce(function(){return _this._updateVisibleEntries()},150));_this._loadReportData();return _this}EmiratesReportController.prototype.sortBy=function sortBy(tableColumn){var _this2=this;if(tableColumn.sortDisabled){return}this._$timeout(function(){for(let col of _this2._tableColumns){if(col===tableColumn){_this2._activeColumn=tableColumn;_this2._activeColumn.sort()}else{col.endSort()}}})};EmiratesReportController.prototype._loadReportData=function(){var ref=_asyncToGenerator(function*(){try{yield this._handledLoadReportData()}catch(e){this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error')}});function _loadReportData(){return ref.apply(this,arguments)}return _loadReportData}();EmiratesReportController.prototype._handledLoadReportData=function(){var ref=_asyncToGenerator(function*(){this.isUpdating=!0;try{const endOfReport=this._date;const startOfReport=pulsarDate(endOfReport).minus(timespan.fromHours(24));this.reportBounds={start:startOfReport,end:endOfReport};this.reportBoundsStrings={start:this._getDateTimeStringsFor(startOfReport),end:this._getDateTimeStringsFor(endOfReport)};const[reportRepsonse,{fatigueThreshold:fatigueThreshold}={}]=yield Promise.all([this._socketService.sendAndWaitForResponse('GetQaReport',this.reportBounds,{timeoutInSeconds:timespan.fromMinutes(7).totalSeconds(),retryOptions:_RetryOptions,throwOnUnexpectedError:!0}),this._organizationDefaultsService.getOrganizationThresholds({retryOptions:_RetryOptions,throwOnUnexpectedError:!0})]);if(!SocketResponse.succeeded(reportRepsonse)){throw new Error(reportRepsonse.status||'Unknown')}this.reportCreationTime=moment(this._dateService.now()).tz(this._timeZoneService.localTimeZone);this.reportCreationTimeString=this._getDateTimeStringsFor(this.reportCreationTime);this.currentFatigueThreshold=fatigueThreshold;const assignmentsByStaffNumber=_getPopulatedAssignmentsByStaffNumber(reportRepsonse.body,this._timeZoneService.localTimeZone);this.allEntries=_.toArray(assignmentsByStaffNumber.values()).map(_getStaffEntryGeneratorForThreshold(fatigueThreshold));this.isUpdating=!1;this._updateVisibleEntries()}finally{this.isUpdating=!1}});function _handledLoadReportData(){return ref.apply(this,arguments)}return _handledLoadReportData}();EmiratesReportController.prototype._getDateTimeStringsFor=function _getDateTimeStringsFor(time){const dateString=Formatters.formatInLocale(time,'DD-MMM',this._timeZoneService.localTimeZone);const timeString=Formatters.formatInLocale(time,'HH:mm',this._timeZoneService.localTimeZone);return`${dateString} ${timeString}`};EmiratesReportController.prototype._updateThresholdStatusMap=function _updateThresholdStatusMap(entries){const flightsByThresholdStatuses=_(entries).flatMap('assignments').flatMap(function(a){return(a.pairing.flights||[]).map(function(f,index){return{flight:f,status:a.fatigueThresholdStatuses[index]}})}).groupBy('status').value();this._thresholdStatusMap={Above:flightsByThresholdStatuses['above-threshold'],At:flightsByThresholdStatuses['at-threshold'],Below:flightsByThresholdStatuses['below-threshold']}};EmiratesReportController.prototype._updateVisibleEntries=function _updateVisibleEntries(){var _this3=this;if(!_.exists(this.allEntries)){return}const entries=(this.searchQuery||'').trim()?this.filteredEntries:this.allEntries;this._$timeout(function(){_this3._updateThresholdStatusMap(entries);_this3._staffReportEntries=entries})};EmiratesReportController.prototype._assignParamsToController=function _assignParamsToController(params){this._changeUserId=params.changeUserId;this._date=params.date;this._timezone=params.timezone};EmiratesReportController.prototype._updateControllerParamsFromUrl=function _updateControllerParamsFromUrl(newStateParams){const{changeUserId:changeUserId,date:date,timezone:timezone}=newStateParams;if(this._changeUserId===changeUserId&&this._date.getTime()===date.getTime()&&this._timezone===timezone){return}this._assignParamsToController(newStateParams);this._loadReportData()};_createClass(EmiratesReportController,[{key:'changeUserId',get:function()

{
return this._changeUserId;
}},{key:'date',get:function()

{
return this._date;
}},{key:'timezone',get:function()

{
return this._timezone;
}},{key:'staffReportEntries',get:function()

{
return this._staffReportEntries;
}},{key:'activeColumn',get:function()

{
return this._activeColumn;
}},{key:'orderBy',get:function()

{
return this._activeColumn.orderBy;
}},{key:'tableColumns',get:function()

{
return this._tableColumns;
}},{key:'itemsPerBatch',get:function()

{
return itemsPerBatch;
}}]);return EmiratesReportController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_handledLoadReportData',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_handledLoadReportData'),_class.prototype)),_class);



const _monthAndDayDisplayOptions={dayFirst:!0};

const _getPopulatedAssignmentsByStaffNumber=function(report,localTimeZone){
const pairingsByPairingId=new Map;
const assignmentsByStaffNumber=new Map;

for(const pairing of report.pairings){
const firstFlight=_.first(pairing.flights);
if(_.exists(firstFlight)){
pairing.formattedPairingStartDate=Formatters.monthAndDayInTimeZone(firstFlight.start,localTimeZone,_monthAndDayDisplayOptions).replace(/\s+/g,'-');
}
for(const flight of pairing.flights){
flight.formattedStartTime=_getFormattedFlightTime(flight.start,localTimeZone);
}
pairingsByPairingId.set(pairing.pairingId,pairing);
}

const numAssignments=report.assignments.length;
for(const assignment of report.assignments){
assignment.pairing=pairingsByPairingId.get(assignment.pairingId);
assignment.changeUserId=assignment.changeUserId||'N/A';

assignment.searchableSubFieldData=_([
assignment.pairing.pairingReference,
assignment.changeUserId,
assignment.pairing.fleet,
assignment.pairing.formattedPairingStartDate,
assignment.assignedRank,
assignment.qualifiedRank].concat(_toConsumableArray(
_getSearchableDataForFlights(assignment.pairing.flights)))).
compact().uniq().value();

if(!assignmentsByStaffNumber.has(assignment.staffNumber)){
assignmentsByStaffNumber.set(assignment.staffNumber,[]);
}

assignmentsByStaffNumber.get(assignment.staffNumber).push(assignment);
}

return assignmentsByStaffNumber;
};

const _getSearchableDataForSingleFlight=function(flight){return[flight.code+flight.num,flight.loc].concat(_toConsumableArray(flight.loc.split('-')))};
const _getSearchableDataForFlights=function(flights){return _.flatMap(flights,_getSearchableDataForSingleFlight)};

const _getStaffEntryGeneratorForThreshold=function(fatigueThreshold){return function(assignments){return _getStaffReportForAssignments(assignments,fatigueThreshold)}};

const _getStaffReportForAssignments=function(assignments,fatigueThreshold){
const _getStatusFromFatigue=function(f){return _getThresholdStatusFromFatigueAndThreshold(f,fatigueThreshold)};

const peakFatigue=_getPeakFatigueFrom(assignments);
const peakFatigueThresholdStatus=_getStatusFromFatigue(peakFatigue);
return{
staffNumber:assignments[0].staffNumber,
assignments:assignments.map(function(a){return _.assign(a,{fatigueThresholdStatuses:a.fatigue.map(_getStatusFromFatigue)})}),
rank:_(assignments).flatMap(_getAssignedAndQualifiedRank).compact().uniq().value().join(', '),
peakFatigue:peakFatigue,
peakFatigueThresholdStatus:peakFatigueThresholdStatus,
numAlerts:assignments.reduce(_countAboveThresholdAlerts,0),
searchableSubFieldData:_(assignments).flatMap('searchableSubFieldData').uniq().value().join(' ')};

};

const _isAboveThreshold=function(thresholdStatus){return thresholdStatus==='above-threshold'};
const _countAboveThresholdAlerts=function(sum,assignment){return sum+assignment.fatigueThresholdStatuses.filter(_isAboveThreshold).length};
const _getAssignedAndQualifiedRank=function(assignment){return _.at(assignment,['assignedRank','qualifiedRank']).map(function(str){return(str||'').trim()})};

const _getThresholdStatusFromFatigueAndThreshold=function(fatigue,threshold){
const thresholdDiff=fatigue-threshold;
return thresholdDiff>=0?
'above-threshold':
thresholdDiff>=-1?
'at-threshold':
'below-threshold';
};

const _getFormattedFlightTime=function(time,tz){return`${Formatters.monthAndDayInTimeZone(time,tz,_monthAndDayDisplayOptions).replace(/\s+/g,'-')} ${Formatters.timeInLocale(time,tz,!1,!0)}`};

const _getPeakFatigueFrom=function(assignments){return Math.max.apply(Math,_toConsumableArray(_.flatMap(assignments,'fatigue')))};

const _isSameOrStartsWithString=function(field,match){return match===field||field.indexOf(match)===0};

module.exports=EmiratesReportController;
//# sourceMappingURL=emiratesReportController.js.map
